import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';
import { PiSwimmingPool, PiTreeEvergreen } from 'react-icons/pi';
import { CgGym } from 'react-icons/cg';
import { GiMeditation, GiPathDistance } from 'react-icons/gi';
import { MdOutlineOutdoorGrill, MdOutlinePeople, MdOutlineStream, MdOutlineVilla } from 'react-icons/md';
import { FaChild } from 'react-icons/fa';
import { GrYoga } from 'react-icons/gr';
import { IoCarSportOutline, IoShieldHalf, IoStorefrontOutline } from 'react-icons/io5';
import { neonMap, textMap } from '../../../../components/ColorMappingOptions';
import ColorEventPage from '../../../LandingPages/ColorEventPage';

function NinaLibyaEvent({
    language
}) {
    const color = "gold";

    const images = [
        "/assets/images/projects/event/libya/libya-bg.svg",
        "/assets/images/projects/azizi-leily/2.webp",
        "/assets/images/projects/azizi-leily/3.webp",
        // "/assets/images/projects/azizi-leily/4.webp"
    ];

    const poster = "/assets/images/projects/azizi-leily/poster.jpg";
    // const webm = "/assets/images/projects/azizi-leily/hero.webm";
    const video = "/assets/images/projects/azizi-leily/azizi-leily.mp4";

    const {
        langs,
        langCode,
        userInfo,
        FINDESTATES_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center">
                        جاهز تبدأ أول خطوة في
                        <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                            استثمارك العقاري؟
                        </span>
                    </h1>
                ) : (
                    <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center capitalize">
                        Ready to take the
                        <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                            first step in your real estate investment?
                        </span>
                    </h1>
                )}

            </>
        );
    }

    const SecondHeading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-2xl lg:text-3xl font-bold gap-1 flex flex-col items-center justify-center">
                        <span>  المؤتمر العقاري الأول من نوعه</span>
                        <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                            في ليبيا!!
                        </span>
                    </h1>
                ) : (
                    <h1 className="text-center text-2xl lg:text-3xl font-bold gap-1 flex flex-col items-center justify-center capitalize">
                        <span>The first-of-its-kind</span>
                        <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                            Real Estate Conference in Libya!!
                        </span>
                    </h1>
                )
                }

            </>
        );
    }

    const ThirdHeading = () => {
        return (
            <>
                {language == "ar" ? (
                    <div className="flex flex-col gap-3 items-center justify-center">
                        <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center">
                            عن
                            <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                المؤتمر
                            </span>
                        </h1>
                        <h1 className="text-center text-xl lg:text-2xl gap-1 flex items-center justify-center">
                            أول حدث استثماري عقاري لدبي يُقام في ليبيا
                        </h1>
                        <p className="text-center text-[#D0D0D0]">
                            تجربة فريدة تجمع أكبر مطوري دبي لأول مرة في طرابلس ومصراتة، مع عروض خاصة، خطط دفع مرنة، وجلسات استشارية فردية تساعدك تختار المشروع الأنسب لميزانيتك وهدفك الاستثمارى
                        </p>
                    </div>
                ) : (
                    <div className="flex flex-col gap-3 items-center justify-center">
                        <h1 className="text-center text-xl lg:text-2xl font-bold gap-1 flex flex-wrap items-center justify-center capitalize">
                            About the
                            <span className={`${color == "gold" ? "primary-text" : textMap[color]} ${color == "gold" ? "" : neonMap[color]}`}>
                                Conference
                            </span>
                        </h1>
                        <h1 className="text-center text-xl lg:text-2xl gap-1 flex items-center justify-center capitalize">
                            Dubai's first real estate investment event to be held in Libya
                        </h1>
                        <p className="text-center text-[#D0D0D0] capitalize">
                            A unique experience bringing together Dubai's biggest developers for the first time in Tripoli and Misrata, with special offers, flexible payment plans, and individual consultations to help you choose the project that best suits your budget and investment goal.
                        </p>
                    </div>
                )
                }

            </>
        );
    }

    const gridDetails = [
        {
            "topic": language == "ar" ? "فرصة عوائد استثمارية" : "Investment Return Opportunity",
            "icon": "/assets/images/projects/event/libya/growth.png",
        },
        {
            "topic": language == "ar" ? "فرصة للحصول على الإقامة الذهبية" : "Opportunity to Obtain Golden Visa",
            "icon": "/assets/images/projects/event/libya/goldenvisa.png",
        },
        {
            "topic": language == "ar" ? "عروض وخصومات حصرية " : "Exclusive Offers & Discounts",
            "icon": "/assets/images/projects/event/libya/discounts.png",
        },
    ];

    const confDetails = [
        {
            heading: language == "ar" ? "اليوم الاول" : "Day 01",
            points: [
                language == "ar" ? "نظرة كاملة على سوق دبي العقاري" : "A complete overview of Dubai's Real Estate Market",
                language == "ar" ? "عروض وفيديوهات المشاريع" : "Project presentations and videos",
                language == "ar" ? "شرح خطط الدفع والخصومات" : "Explanation of payment plans and discounts",
                language == "ar" ? "تسجيل العملاء وجلسات استشارية أولية" : "Customer registration and initial consultation sessions",
            ]
        },
        {
            heading: language == "ar" ? "اليوم الثاني" : "Day 02",
            points: [
                language == "ar" ? "عرض تفصيلي للمشاريع" : "Detailed project overview",
                language == "ar" ? "مقابلات استشارية موسّعة" : "Extended consultation interviews",
                language == "ar" ? "تقديم العروض الخاصة والحجز المبدئي" : "Special offers and advance booking",
            ]
        },
        {
            heading: language == "ar" ? "اليوم الثالث" : "Day 03",
            points: [
                language == "ar" ? "مقابلات VIP" : "VIP Interviews",
                language == "ar" ? "توقيع الاتفاقات والحجوزات" : "Signing agreements and reservations",
                language == "ar" ? "تصوير وتوثيق إنجاز الجولة" : "Filming and documenting the tour's achievements",
            ]
        }
    ];

    const datesDetails = [
        {
            city: language == "ar" ? "طرابلس" : "Tripoli",
            date: language == "ar" ? "16,17,18 ديسمبر" : "16, 17, 18 December 2025",
            venue: language == "ar" ? "" : "",
        },
        {
            city: language == "ar" ? " مصراتة" : "Misrata",
            date: language == "ar" ? "20,21,22 ديسمبر" : "20, 21, 22 December 2025",
            venue: language == "ar" ? "فندق الماسة مصراتة" : "Al Masa Hotel Misrata",
        }
    ];

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/riviera",
                        ar: "/projects/azizi/riviera/ar",
                        fa: "/projects/azizi/riviera/fa",
                        tr: "/projects/azizi/riviera/tr",
                    }}
                /> */}
            <ColorEventPage
                color={color}
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                heading2={<SecondHeading />}
                heading3={<ThirdHeading />}
                gridDetails={gridDetails}
                confDetails={confDetails}
                datesDetails={datesDetails}
                base_url={FINDESTATES_URL}
                developer="Libya"
                project="Event"
                projectName="Event"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                cities={{ en: ["Tripoli", "Misrata"], ar: ["طرابلس", "مصراته"] }}
                // enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "4 Bedrooms"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={101}
            />
        </>
    );
}

export default NinaLibyaEvent;
